import React from "react";
import PredictionMetrics from "../../atoms/predictionMetrics/PredictionMetrics.jsx";
import SimulationTable from "../simulationTable/SimulationTable.jsx";
import "./EventCard.css";

const EventCard = ({
  item,
  isSelected,
  isLoading,
  onSelect,
  formatDate,
  formatDateShort,
  convertToHectares,
}) => {
  const fire = item.fire;

  return (
    <div
      className={`event-card ${isSelected ? "event-card--selected" : ""}`}
      onClick={() => onSelect(fire.id)}
    >
      <div className="event-card__header">
        <span className="event-ref-badge">{fire.reference}</span>
        <span className="event-address">{fire.address}</span>

        <div className="event-card__header-right">
          {isLoading && (
            <div className="event-card__inline-loader">
              <div className="event-card__spinner" />
              <span className="event-card__loading-text">Chargement…</span>
            </div>
          )}
          <span className="event-date-badge">{formatDateShort(fire.created_at)}</span>
        </div>
      </div>

      <div className="event-card__body">
        <div className="event-meta-row">
          <div className="meta-item">
            <span className="meta-label">Météo</span>
            <span className="meta-value">
              {fire.type === "dynamic" ? "Satellite" : "Simulation"}
            </span>
          </div>
          <div className="meta-item">
            <span className="meta-label">Surface</span>
            <span className="meta-value">
              {convertToHectares(fire.area_m2)} ha
            </span>
          </div>
          <div className="meta-item">
            <span className="meta-label">Contour primaire</span>
            <span className="meta-value">
              {formatDate(fire.date_first_outline)}
            </span>
          </div>
           <div className="meta-item">
            <span className="meta-label">Origine du feu</span>
            <span className="meta-value">
              {formatDate(fire.date)}
            </span>
          </div>
        </div>

        <PredictionMetrics fire={fire} />
        <SimulationTable item={item} />
      </div>
    </div>
  );
};

export default EventCard;